import React from 'react';

export default function (props) {
    return (
        <div className={props.className}>
            {
                props.label ? <div className="mb-2">{props.label}</div> : null
            }
            <div className="input-group-sm">
                <textarea
                    name={props.name}
                    value={props.value}
                    rows={props.rows || 5}
                    onChange={props.onChange}
                    className="form-control"
                    placeholder={props.placeholder}
                    defaultValue={props.defaultValue}
                />
            </div>
        </div>
    )
}
